import { InjectionToken } from '@angular/core';
import { TypeActivityPlatformApiService } from '../type-activity-platform-api.service';

export const HTTP_TYPE_ACTIVITY_PLATFORM_SERVICE =
  new InjectionToken<TypeActivityPlatformApiService>(
    'TypeActivityPlatformApiService'
  );

export const TYPE_ACTIVITY_PLATFORM_API_PROVIDER = {
  provide: HTTP_TYPE_ACTIVITY_PLATFORM_SERVICE,
  useClass: TypeActivityPlatformApiService,
};
